import { StyleSheet, TextStyle } from 'react-native'
export const basicSharedStyles = StyleSheet.create({
    container: {
        marginLeft: 30,
        marginRight: 30,
        marginTop: 10
    },
    btnDetail: {
        width: 80,
        height: 40,
        backgroundColor: '#ebe9e9',
        borderRadius: 100,
        padding: 10
    },
    cellNoWrap: {
        whiteSpace: 'nowrap'
    } as TextStyle,
})